/**
 * Conversation utility functions
 * Used by ConversationHistory component
 */

export interface Conversation {
    id: string
    title: string
    timestamp: number
    messageCount?: number
}

/**
 * Groups conversations by date categories
 * @param conversations - Array of conversations to group
 * @returns Object with conversations grouped by date
 */
export function groupConversations(conversations: Conversation[]) {
    const groups: { [key: string]: Conversation[] } = {
        'Hoje': [],
        'Ontem': [],
        'Últimos 7 dias': [],
        'Mais antigas': []
    }

    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const yesterday = new Date(today)
    yesterday.setDate(yesterday.getDate() - 1)
    const lastWeek = new Date(today)
    lastWeek.setDate(lastWeek.getDate() - 7)

    conversations.forEach(conv => {
        const date = new Date(conv.timestamp)
        const convDate = new Date(date.getFullYear(), date.getMonth(), date.getDate())

        if (convDate.getTime() === today.getTime()) {
            groups['Hoje'].push(conv)
        } else if (convDate.getTime() === yesterday.getTime()) {
            groups['Ontem'].push(conv)
        } else if (date > lastWeek) {
            groups['Últimos 7 dias'].push(conv)
        } else {
            groups['Mais antigas'].push(conv)
        }
    })

    return groups
}

/**
 * Formats a date/timestamp into relative time string
 * @param date - Date, string, or number timestamp
 * @returns Relative time string (e.g., "agora", "5m", "2h", "3d")
 */
export function getRelativeTime(date: Date | string | number): string {
    const now = new Date()
    const past = new Date(date)
    const diffInSeconds = Math.floor((now.getTime() - past.getTime()) / 1000)

    if (diffInSeconds < 60) return 'agora'
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m`
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h`
    if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)}d`
    return past.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
}
